function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from "react";
import DealsLayout from "../DealsLayout/newIndex";
import { getCategoryIdByName } from "../../../../utils/helpers";
import { isAdani } from "../../../../utils/isClient";
import BsArrowRight from "@meronex/icons/bs/BsArrowRight";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DealSection(_ref) {
  var offers = _ref.offers,
    type = _ref.type,
    className = _ref.className,
    hide = _ref.hide,
    isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    subHeading = _ref.subHeading,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    appType = _ref.appType,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var onClick = function onClick() {
    var dealRoute = isRewards === true ? "/reward-dealListing" : "/dealListing";
    switch (type) {
      case "Home Services":
        history.push(dealRoute + "?categoryID=2&categoryName=Home Services");
        return;
      case "Home Furnishings":
        history.push(dealRoute + "?categoryID=11&categoryName=Home Furnishings");
        return;
      case "Lifestyle":
        history.push(dealRoute + "?categoryID=1&categoryName=Lifestyle");
        return;
      case "Electronics":
        history.push(dealRoute + "?categoryID=10&categoryName=Electronics");
        return;
      case "Finance":
        history.push(dealRoute + "?categoryID=3&categoryName=Finance");
        return;
      case "EXTERNAL OFFERS":
        history.push(dealRoute + "?categoryID=9&categoryName=External Deals");
        return;
      case "YOUR DIGITAL AMENITIES":
        history.push(dealRoute + "?categoryID=5&categoryName=Digital Amenities");
        return;
      case "OFFERS OF THE MONTH":
        offers.forEach(function (offer) {
          var _window;
          (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("OfferOfTheMonthClicked", {
            dealId: offer.id,
            category: offer.categoryName,
            tag: "Offers of the Month",
            SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
            DealPoint: "".concat(offer === null || offer === void 0 ? void 0 : offer.points),
            Mrp: "".concat(offer === null || offer === void 0 ? void 0 : offer.productMrp),
            RedemptionType: "".concat(offer === null || offer === void 0 ? void 0 : offer.redemptionType)
          });
        });
        history.push(dealRoute + "?tagID=52&tagName=Offers of the Month");
        return;
      case "OTHER OFFERS FROM THIS BRAND":
        history.push("/dealListing?brandID=".concat(offers[0].vendorId, "&brandName=").concat(offers[0].vendorName));
        return;
      case "SIMILAR OFFERS":
        history.push("/dealListing?categoryID=".concat(getCategoryIdByName(offers[0].categoryName), "&categoryName=").concat(offers[0].categoryName));
        return;
      case "OTHER DEALS IN THIS BUNDLE":
        history.push(dealRoute + "?categoryID=8&categoryName=Bundle");
        return;
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex  ".concat(isRewards ? 'justify-center' : 'justify-between', " w-full items-center"),
      children: [/*#__PURE__*/_jsx("h1", {
        onClick: onClick,
        className: "".concat(isPoints ? "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-3xl text-center font-medium") : "font-semibold text-primary uppercase text-base", " ").concat(isRewards ? "" : "hover:border-b-2 hover:border-primary hover:pb-2 cursor-pointer"),
        children: type
      }), !hide && (offers === null || offers === void 0 ? void 0 : offers.length) >= 4 && !isRewards && /*#__PURE__*/_jsx("p", {
        onClick: onClick,
        className: "z-10 text-sm font-semibold capitalize text-primary font-sans cursor-pointer ",
        children: /*#__PURE__*/_jsx(BsArrowRight, {
          className: "w-6 h-6 text-primary"
        })
      })]
    }), subHeading && /*#__PURE__*/_jsx("p", {
      className: "".concat(isPoints ? "text-center mt-4 text-sm lg:text-lg" : ""),
      children: subHeading
    }), /*#__PURE__*/_jsx("div", {
      id: "DealsLayout",
      className: "w-full gap-3 lg:gap-7 ".concat(isRewards ? "flex flex-wrap mt-8" : "flex flex-wrap mt-4"),
      children: offers === null || offers === void 0 ? void 0 : offers.map(function (offer) {
        var modifiedOffer = _objectSpread(_objectSpread({}, offer), {}, {
          isRewards: isRewards,
          isPoints: isPoints,
          config: config,
          redux: redux,
          router: router,
          appType: appType,
          winnreAuth: winnreAuth,
          winnreNoAuth: winnreNoAuth,
          cmsClient: cmsClient
        }); // Add isRewards to the offer object
        return /*#__PURE__*/_jsx(DealsLayout, _objectSpread({}, modifiedOffer));
      })
    })]
  });
}
export default DealSection;